import React, { Component } from 'react';
import {
  Create,
  TextInput,
  SimpleForm,
  ReferenceInput,
  SelectInput,
  DateInput,
  BooleanInput,
  required,
} from 'react-admin';
import { withStyles } from '@material-ui/core/styles';

const customerRenderer = record => `${record.first_name} ${record.last_name}`;

const styles = {
  root: {
    marginTop: '24px',
  },
};

class CreateForm extends Component {
  state = {
    isFamilyCar: false,
    carBrandID: '',
  };

  handleChangeFamilyCar = (e, checked) => {
    this.setState({ isFamilyCar: checked });
  };

  handleChangeCarBrand = (e, data) => {
    this.setState({ carBrandID: data });
  };

  renderContainer() {
    const { classes, ...rest } = this.props;
    const { isFamilyCar, carBrandID } = this.state;
    return (
      <Create title={'New Customer Car'} {...rest}>
        <SimpleForm>
          <ReferenceInput label="Customer" source="user_id" reference="customers" validate={required()} perPage={-1}>
            <SelectInput optionText={customerRenderer} />
          </ReferenceInput>
          <BooleanInput
            source="is_family_car"
            label="Family Car"
            // input={{ name: 'is_family_car', checked: isFamilyCar, onChange: this.handleChangeFamilyCar }}
            classes={{ root: classes.root }}
            onChange={this.handleChangeFamilyCar}
          />
          {isFamilyCar && <TextInput source="relationship" validate={required()} />}
          {isFamilyCar && <TextInput source="relationship_name" label="Full Name" validate={required()} />}
          {isFamilyCar && <TextInput source="relationship_mobile" label="Mobile Number" validate={required()} />}
          <ReferenceInput
            label="Car Brand"
            source="car_brand_id"
            reference="brands"
            validate={required()}
            onChange={this.handleChangeCarBrand}
            perPage={-1}
          >
            <SelectInput optionText="name" />
          </ReferenceInput>
          <ReferenceInput
            label="Car Model"
            source="car_model_id"
            reference="models"
            perPage={-1}
            filter={{ car_brand_id: carBrandID }}
            validate={required()}
          >
            <SelectInput optionText="name" />
          </ReferenceInput>
          <TextInput source="reg_no" validate={isFamilyCar ? undefined : required()} />
          {!isFamilyCar && <DateInput source="reg_date" validate={required()} />}
          {!isFamilyCar && <TextInput source="chasis_no" label="Chassis no" />}
          {!isFamilyCar && (
            <ReferenceInput
              label="Sales Consultant"
              source="sales_advisor_id"
              reference="sales_advisors"
              perPage={-1}
              filter={{ car_brand_id: carBrandID }}
              validate={required()}
            >
              <SelectInput optionText="full_name" />
            </ReferenceInput>
          )}
          {!isFamilyCar && (
            <ReferenceInput
              label="Service Consultant"
              source="service_consultant_id"
              reference="service_consultants"
              perPage={-1}
              filter={{ car_brand_id: carBrandID }}
              validate={required()}
            >
              <SelectInput optionText="full_name" />
            </ReferenceInput>
          )}
          <DateInput source="last_service_date" />
        </SimpleForm>
      </Create>
    );
  }

  render() {
    return this.renderContainer();
  }
}

export default withStyles(styles)(CreateForm);



// WEBPACK FOOTER //
// ./src/containers/CustomerCar/CreateForm.js